var $423189e883439a48$exports = {};
$423189e883439a48$exports = {
    "actions": `Azioni`,
    "hideButtonLabel": `Mostra meno`,
    "noTags": `Nessuno`,
    "showAllButtonLabel": (args, formatter)=>`Mostra tutto (${formatter.number(args.tagCount)})`
};


export {$423189e883439a48$exports as default};
//# sourceMappingURL=it-IT.mjs.map
